import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { Flex, Paper } from '@shared/components';

import { SummaryCard, type SummaryCardProps } from '../../components';

import { formatSummaryQuestion } from './utils';

export default function SummaryCardGroup() {
  const {
    qConfigData: { totalQuestions, metadata },
  } = useQConfig();

  const { calculated, notCalculated, single, itemSet, easy, medium, hard } =
    formatSummaryQuestion(metadata);

  const totalAddedQuestions = (calculated ?? 0) + (notCalculated ?? 0);

  const getPercentage = (questions: number | null) => {
    if (questions === null || totalAddedQuestions === 0) return 0;
    return ((questions / totalQuestions) * 100).toFixed(2);
  };

  const mockData: SummaryCardProps[] = [
    {
      title: 'จำนวนข้อสอบ',
      items: [
        {
          title: 'จำนวนทั้งหมด',
          amount: `${totalAddedQuestions}/${totalQuestions}`,
          percentage: getPercentage(totalAddedQuestions),
          sx: {
            color: (theme) =>
              totalAddedQuestions > totalQuestions
                ? theme.palette.error.main
                : theme.palette.text.primary,
          },
        },
        {
          title: 'Single',
          amount: single,
          percentage: getPercentage(single),
        },
        { title: 'Item Set', amount: itemSet, percentage: getPercentage(itemSet) },
      ],
    },
    {
      title: 'ประเภทข้อสอบ',
      items: [
        {
          title: 'คำนวณ',
          amount: calculated,
          percentage: getPercentage(calculated),
        },
        {
          title: 'ไม่คำนวณ',
          amount: notCalculated,
          percentage: getPercentage(notCalculated),
        },
      ],
    },
    {
      title: 'ระดับความยาก',
      items: [
        {
          title: 'ง่าย',
          amount: easy,
          percentage: getPercentage(easy),
        },
        {
          title: 'กลาง',
          amount: medium,
          percentage: getPercentage(medium),
        },
        {
          title: 'ยาก',
          amount: hard,
          percentage: getPercentage(hard),
        },
      ],
    },
  ];

  return (
    <Paper>
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(4),
          justifyContent: 'space-around',
          p: theme.spacing(6),
        })}
      >
        {mockData.map((card) => {
          const key = `${card.title}`;
          return <SummaryCard key={key} {...card} />;
        })}
      </Flex>
    </Paper>
  );
}
